import { busApi } from 'Api/axios'

export const updateOdvWebStatus = async ({
  saleOrderId,
  headerStatusId,
  statusName,
}) => {
  const { data } = await busApi.patch(`/UpdateSaleOrderWebStatus`, {
    saleOrderId,
    headerStatusId,
    statusName,
  })
  return data
}

export const updateOdvPaymentMethod = async ({
  saleOrderId,
  isCommercialCredit,
  amount,
  orderNumber,
  creditAccount,
}) => {
  if (!saleOrderId || amount == null) {
    throw new Error('saleOrderId and amount are required')
  }

  const paymentMethodPayload = isCommercialCredit
    ? {
        CreditoComercial: {
          TransactionKey: null,
          PaymentTypeId: 'CREDITO COMERCIAL',
          TenderType: 0,
          Amount: amount,
          PaidAmount: amount,
          PaymentReferenceNumber: creditAccount?.CreditAccountNumber,
          OrderNumber: orderNumber,
          PaymentAttributes: [],
        },
      }
    : {
        PendienteDePagoContado: {
          TransactionKey: null,
          PaymentTypeId: 'PENDIENTE DE PAGO CONTADO',
          TenderType: 0,
          Amount: amount,
          PaidAmount: amount,
          PaymentAttributes: [],
        },
      }

  const { data } = await busApi.patch(`/UpdateSaleOrderWebPaymentMethod`, {
    SaleOrderId: saleOrderId,
    PaymentMethod: [paymentMethodPayload],
  })

  if (data?.IsSuccess === false) {
    const error = new Error(data.Message)
    error.response = { data }
    throw error
  }

  return data
}

export const fetchGetOdvDetails = async ({ saleOrderId }) => {
  const { data } = await busApi.get(
    `/SearchBySaleOrderId?OrderSaleId=${saleOrderId}`
  )
  return data
}

export const postNotifyDispatch = async ({ documentHeaderId }) => {
  const { data } = await busApi.post(`/NotifyCreateRequestDispatch`, {
    documentHeaderId,
  })
  return data
}

/**
 * Searches for invoices in the system using various filtering parameters.
 *
 * @param {Object} props - Search parameters.
 * @param {string} props.integrationInvoiceId - Integration invoice ID.
 * @param {string} props.customerName - Customer's name.
 * @param {string} props.documentNumber - Document number.
 * @param {string} props.purchaseOrderId - Purchase order ID.
 * @param {string} props.branchOfficeName - Branch office name.
 * @param {number} props.totalAmount - Total invoice amount.
 * @param {string} props.salespersonName - Salesperson's name.
 * @param {string} props.initDate - Start date for filtering in YYYY-MM-DD format.
 * @param {string} props.endDate - End date for filtering in YYYY-MM-DD format.
 * @param {number} props.pageNumber - Page number for pagination.
 * @param {number} props.pageSize - Number of items per page.
 *
 * @returns {Promise<Object>} Response data containing the list of found invoices.
 */
export const getSearchInvoicesVadIvend = async props => {
  const { data } = await busApi.post('/SearchIntegrationDocuments', {
    ...props,
  })
  return data
}

/**
 * Fetches all branch offices available in the system.
 * @returns {Promise<Object>} Response data containing the list of branch offices.
 */

export const getSearchInvoicesVadIvendBranches = async ({ branchID }) => {
  const { data } = await busApi.get(`/BranchOffices/${branchID}`)
  return data
}

export const searchInoviceDocumentDetailService = async integrationInvoceId => {
  const { data } = await busApi.get(
    `IntegrationInvoiceDetail/${integrationInvoceId}`
  )

  return data
}
